export const formatRoundText = ({
	roundText,
	showGold = false,
	formatRound = false
}: {
	roundText?: string;
	showGold?: boolean;
	formatRound?: boolean;
}) => {
	if (!roundText) {
		return '';
	}

	let formattedText = roundText;
	if (formattedText === 'Quarter-Finals' || formattedText === 'Quarter Finals') {
		formattedText = 'Quarterfinals';
	} else if (formattedText === 'Semi-Finals' || formattedText === 'Semi Finals') {
		formattedText = 'Semifinals';
	} else if (formattedText === 'Finals' && showGold) formattedText = 'Gold';

	if (!formatRound) return formattedText;

	if (formattedText.startsWith('Round')) {
		const roundTextSplit = formattedText.split(' ');
		let formattedRoundText = '';
		if (roundTextSplit[1] && roundTextSplit[1] === 'of') {
			return formattedText;
		}
		if (roundTextSplit[0]) {
			formattedRoundText += roundTextSplit[0];
		}
		if (roundTextSplit[1]) {
			formattedRoundText += ' of ';
			formattedRoundText += roundTextSplit[1];
		}
		return formattedRoundText;
	}

	return formattedText;
};
